import styled from 'react-emotion';
import theme from '@lyearn-team/theme-config';

export const LoginSmallText = styled.p`
  font-size: 12px;
  color: ${theme.color.dark.iron};
  a {
    color: ${theme.color.dark.amethyst};
  }
`;

export const LoginNormalText = styled(LoginSmallText)`
  font-size: 14px;
`;

export const LoginContentHeading = styled.div`
  font-family: PlayfairDisplay;
  font-size: 32px;
  margin-bottom: 8px;
  color: ${theme.color.dark.silver};
  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 63px 55px;
  background: ${theme.color.dark.saturn};
`;

export const MainWrapper = styled.div`
  display: flex;
  width: 100%;
  /* background: #fff; */
  max-width: 100%;
  min-height: 100vh;
  margin-top: -72px;
  flex-direction: column;
`;

export const InnerWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  min-height: 100%;
  position: relative;
`;

export const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 793px;
  margin: 0 auto;
`;
